import { FormFieldModel } from './form-field.model';
import { AbstractFormFieldComponent } from '../components/FormField/abstract-form-field.component';
import { Type } from '@angular/core';
import { DisplayElementModel } from './display-element.model';
import { ResizeDirectionEnum } from '../../Forms/components/TextareaInput/textarea-input.component';

export interface TextFieldStyle {
    indent?: number;
}
export class TextFieldModel implements FormFieldModel {
    fieldComponent: Type<AbstractFormFieldComponent>;
    property: string;
    label: string;
    description: string;
    multiline: boolean;
    maxLength: number;
    placeholder: string;
    bottomMargin: boolean;
    tooltip?: string;
    validator?: (value: string) => string;
    disabledPlaceholder?: string;
    appearCondition?: (displayElement: DisplayElementModel) => boolean;
    style?: TextFieldStyle;
    resizeDirections?: ResizeDirectionEnum;
    required?: boolean;
    trimValue?: boolean;
    icon?: string;

    constructor(
        fieldComponent: Type<AbstractFormFieldComponent>,
        property: string,
        label: string,
        description: string,
        multiline: boolean,
        maxLength?: number,
        placeholder?: string,
        bottomMargin?: boolean,
        tooltip?: string,
        validator?: (value: string) => string,
        disabledPlaceholder?: string,
        appearCondition?: (displayElement: DisplayElementModel) => boolean,
        style?: TextFieldStyle,
        resizeDirection?: ResizeDirectionEnum,
        required?: boolean,
        trimValue?: boolean,
        icon?: string
    ) {
        this.fieldComponent = fieldComponent;
        this.property = property;
        this.label = label;
        this.description = description;
        this.multiline = multiline;
        this.maxLength = maxLength;
        this.placeholder = placeholder ? placeholder : '';
        this.bottomMargin = bottomMargin;
        this.tooltip = tooltip;
        this.validator = validator;
        this.disabledPlaceholder = disabledPlaceholder;
        this.appearCondition = appearCondition;
        this.style = style;
        this.resizeDirections = resizeDirection ?? ResizeDirectionEnum.none;
        this.required = required ?? false;
        this.trimValue = trimValue ?? false;
        this.icon = icon;
    }
}
